import { SET_TICKETS_AVAILABLE } from "./mutation-types";
export default {
  [SET_TICKETS_AVAILABLE](state: any, isQuotaAvailable: boolean) {
    state.isQuotaAvailable = isQuotaAvailable;
  },
};
